import { render, staticRenderFns } from "./RedPacketOpen.vue?vue&type=template&id=dadab3b2&scoped=true"
import script from "./RedPacketOpen.vue?vue&type=script&lang=js"
export * from "./RedPacketOpen.vue?vue&type=script&lang=js"
import style0 from "./RedPacketOpen.vue?vue&type=style&index=0&id=dadab3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadab3b2",
  null
  
)

export default component.exports